import { MetricModel } from 'src/app/shared/models/metric.model'
import {
  createPaintExpression,
  getProbabilityMetricPaint,
  getSpeedMetricPaint,
} from '../utils/paint/rollouts-map-metrics-paint-utils'

import { defaultExpression } from 'src/app/shared/utils/metric.utils'
import { rolloutLegendSpeedLimit, rolloutLegendProbability } from './legends/rollouts-legends'

export enum RolloutsMapMetrics {
  RolloutsMap_SpeedLimit = 'rt_speedLimit',
  RolloutsMap_Probability = 'rt_probability',
}

export const getMetricFromMap = (metric: RolloutsMapMetrics | string): MetricModel => {
  return (
    RolloutsMapMetricsMap.get(metric) || {
      expression: defaultExpression,
      name: 'default',
      key: 'default',
    }
  )
}

export const RolloutsMapMetricsMap = new Map<string, MetricModel>()
RolloutsMapMetricsMap.set(RolloutsMapMetrics.RolloutsMap_SpeedLimit, {
  name: 'speedLimit',
  expression: createPaintExpression('speedLimit', getSpeedMetricPaint('speedLimit')),
  key: RolloutsMapMetrics.RolloutsMap_SpeedLimit,
  legend: rolloutLegendSpeedLimit,
})

RolloutsMapMetricsMap.set(RolloutsMapMetrics.RolloutsMap_Probability, {
  name: 'probability',
  expression: createPaintExpression('probability', getProbabilityMetricPaint('probability')),
  key: RolloutsMapMetrics.RolloutsMap_Probability,
  legend: rolloutLegendProbability,
})
